import { Checkbox } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { colorStore } from '@/features/queueColors';

import { checkboxStyles, optionItemStyles } from '../../styles';
import { SelectorOption } from '../../types';

import s from './SelectorOption.module.scss';

type SelectorOptionProps<T = string> = {
  option: SelectorOption<T>;
  isSelected: boolean;
  getOptionLabel: (option: SelectorOption<T>) => string;
  props: React.HTMLAttributes<HTMLLIElement>;
};

export const SelectorOptionItem = observer(
  <T extends string>({ option, isSelected, getOptionLabel, props }: SelectorOptionProps<T>) => {
    const color = colorStore.getColorByPrefix(option.label);
    const needsBorder = colorStore.needsBorder(option.label);

    return (
      <li
        {...props}
        key={option.id}
        className={s.optionItem}
        style={{
          ...props.style,
          ...optionItemStyles,
        }}
      >
        <div className={s.option}>
          <Checkbox checked={isSelected} readOnly disableRipple size="small" sx={checkboxStyles} />
          <div className={s.option_content}>
            <p
              className={s.option_label}
              style={{
                color,
                ...(needsBorder && {
                  textShadow: '0 0 1px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0, 0, 0, 0.5)',
                }),
              }}
            >
              {getOptionLabel(option)}
            </p>
            {option.description && <p className={s.option_description}>{option.description}</p>}
          </div>
        </div>
      </li>
    );
  },
) as <T extends string>(props: SelectorOptionProps<T>) => React.ReactElement;
